const icon = require('vue-svgicon');
icon.register({
    'cancel': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.326 3.3A7.077 7.077 0 0115.111 8 7.11 7.11 0 018 15.11a7.077 7.077 0 01-4.7-1.784l-.002.002-.041-.04a7.155 7.155 0 01-.544-.544l-.042-.043.002-.002A7.077 7.077 0 01.89 8 7.11 7.11 0 017.999.89c1.805 0 3.447.677 4.7 1.784l.003-.002.041.041c.191.172.373.354.545.545l.04.041-.002.002zM8 14.223A6.223 6.223 0 0014.222 8c0-1.558-.593-2.965-1.54-4.057l-8.739 8.74c1.092.947 2.499 1.54 4.057 1.54zM1.778 8A6.222 6.222 0 018 1.777c1.558 0 2.964.593 4.056 1.54l-8.74 8.74C2.37 10.964 1.778 9.557 1.778 8z" _fill="#9C9BA9"/>`,
    },
});
